import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextField,
  TextInput,
  TitleProps,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { CompanyDto } from '../../../core/dto/company.dto'

interface CompanyTitleProps extends TitleProps {
  record?: CompanyDto
}

const validateCompanyEdit = (values: CompanyDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

const EditTitle = (props: CompanyTitleProps) => {
  const { record } = props
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.companies.titles.edit')}: {record?.id}.{' '}
      {record?.name}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const CompanyEdit = (props: EditProps) => (
  <Edit {...props} title={<EditTitle />} actions={false}>
    <SimpleForm
      redirect="show"
      validate={validateCompanyEdit}
      toolbar={<EditToolbar />}
    >
      <TextField source="id" label="ID" />
      <TextInput source="name" isRequired />
    </SimpleForm>
  </Edit>
)
